import { useState } from 'react';

import { logError } from '@/infra/observability';
import type { TUseLocalStorageReturn } from './local-storage.types';

/** Hook genérico para persistência em localStorage com parse/stringify automático. */
export function useLocalStorage<T = unknown>(
  key: string,
  initialValue?: T,
): TUseLocalStorageReturn<T> {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch {
      return initialValue;
    }
  });

  const setValue = (value: unknown, store: string) => {
    try {
      const keepValue: Record<string, unknown> = {
        ...((storedValue as Record<string, unknown>) || {}),
        [store]: value,
      };
      setStoredValue(keepValue as T);
      localStorage.setItem(key, JSON.stringify(keepValue));
    } catch (error) {
      logError('useLocalStorage: falha ao salvar no localStorage', { key, store }, error instanceof Error ? error : undefined);
    }
  };

  return { storedValue, setValue };
}
